export default {
  g: {
    common_name: 'Ragione Sociale',
    customer_type: 'Segmento',
    full_name: 'Ragione Sociale',
    first_name: 'Nome',
    last_name: 'Cognome',
    piva_cf: 'PIVA / C.Fisc',
    email: 'Email',
    work_phone: 'Tel. Lavoro',
    mobile_phone: 'Cellulare',
    address: 'Indirizzo',
    city: 'Città',
    cap: 'CAP',
    region: 'Provincia',
    state: 'Nazione',
    created: 'Creato',
    updated: 'Aggiornato',
    removed: 'Rimosso',
    remove: 'Rimuovi',
    details: 'Dettagli',
    go_to_details: 'Vedi dettagli',
    actions: 'Azioni',
    view: 'Vedi',
    edit: 'Edita',
    delete: 'Rimuovi',
    manage: 'Gestisci',
    cancel: 'Cancella',
    id: '#',
    status: 'Stato',
    ok: 'Ok',
    proced: 'Procedi',
    confirm: 'Confermo',
    devices: 'Dispositivi',
    tickets: 'Tickets',
    customer: 'Cliente',
    platform: 'Piattaforma',
    plan: 'Piano',
    plan_type: 'Tipo Piano',
    type: 'Tipo',
    os: 'OS',
    device: 'Dispositivo',
    phone_number: 'Num. telefono',
    imei: 'IMEI',
    last_access: 'Ultimo Accesso',
    mode: 'Modalità',
    activity: 'Actività',
    category: 'Categoria',
    subcategory: 'Sotto categoria',
    schedule_date: 'Data appuntamento',
    manage_date: 'Gestito',
    managed_by: 'Gestito da',
    closing_date: 'Chiuso',
    user: 'Utente',
    users: 'Utenti',
    email_desc: 'L\'indirizzo email del cliente viene usato per il login.',
    phone_number_desc: 'Il numero di telefono del cliente. Può essere usato come login alternativo.',
    description: 'Descrizione',
    resolution: 'Esito',
    valid_until: 'Valido fino',
    date_creation: 'Data Creazione',
    date_opening: 'Data Apertura',
    date_activity: 'Data Attività',
    duration: 'Durata',
    start_manage: 'Avvia Intervento',
    resume_mange: 'Riprendi Intervento',
    end_manage: 'Concludi Intervento',

    assign_ticket: 'Assegna Ticket',
    reassign_ticket: 'Riassegna Ticket',
    close_ticket: 'Chidi ticket',
    reschedule_ticket: 'Ripianifica Ticket',
    cancel_ticket: 'Annulla Ticket',

    brand_model: 'Marca e Modello',
    status_change: 'Cambia stato',
    resolution_change: 'Cambia Esito',

    send: 'Invia',
    start: 'Avvia',
    stop: 'Stop',
    remote_access: 'Accesso remoto',
    push_notification: 'Notifica push',

    subscriptions: 'Piani sottoscritti',
    payment_method: 'Metodo Pagamento',
    date_start: 'Data Avvio',
    date_expiration: 'Data termine',
    date_next_payment: 'Prossimo pagamento',
    reset_password: 'Reimposta password',
    add_users: 'Aggiungi degli utenti a questo cliente.',

    serial: 'Seriale',
    model: 'Modello',
    version: 'Versione',
    last_login_at: 'Ultimo accesso',
    last_activity_at: 'Ultima attività',
    installed_at: 'Data installazione',
    has_error: 'In Errore',
    referent: 'Referente',

    name: 'Nominativo',
    provider: 'Provider',
    profile: 'Profilo Linea',
    line_number: 'Numero Linea',
    updated_at: 'Ultimo aggiornamento',
    online_since: 'Online Da',
    last_activity: 'Ultima attività',
    last_startup: 'Ultima accensione',
    sim_iccid: 'ICCID SIM',
    has_warning: 'In allarme',
    logged_at: 'Registrato',
    level: 'Livello',
    event: 'Evento',
    events: 'Eventi',
    open_ticket: 'Apri Ticket',
    monitored: 'Monitorato',
    warning: 'Attenzione',
    loading_message: 'Caricamento dati in corso... Si prega di attendere.',
    choice_lang: 'Cambia lingua',
    is_online: 'Online',
    search: 'Cerca',
    filter: 'Filtra',

    level_low: 'Basso',
    level_medium: 'Medio',
    level_high: 'Alto',
  },
};



// WEBPACK FOOTER //
// ./src/locales/it.js